// token存储的key
const TOKEN_KEY = 'token'

/**
 * 存储token到localStorage
 * @param {string} token - 令牌
 */
export function setToken(token, KEY = TOKEN_KEY) {
    return localStorage.setItem(KEY, token)
}

/**
 * 从localStorage获取token
 * @returns {string} token
 */
export function getToken(KEY = TOKEN_KEY) {
    return localStorage.getItem(KEY)
}

/**
 * 从localStorage移除token
 */
export function removeToken(KEY = TOKEN_KEY) {
    return localStorage.removeItem(KEY)
}